import React from 'react'
import { connect } from "react-redux";
import BroadcastBannerTable from "./BroadcastBanner"

const GiftBanner = () => {
  return (
    <BroadcastBannerTable bannerType={1} />
  )
}

export default connect(null, {  })(
  GiftBanner
);

